import React from 'react';
import { GlobalStyles } from '@utex/ui-kit';
import { stylesUTCom } from './styles';
import { SerializedStyles } from '@emotion/react';

interface Props {
  styles?: SerializedStyles[];
}

export function GlobalStylesUTCom(props: Props) {
  const { styles = [] } = props;
  
  return (<GlobalStyles fonts={['geometria']} defaultFont="geometria" styles={[stylesUTCom, ...styles]} />);
}
